import "./Contact.css";
import { Phone, Mail, MapPin } from "lucide-react";
import { useState } from "react";
import axios from "axios";

const Contact = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const response = await axios.post(
      "https://knsonline.in/uat/RestAPI_V1/cp/v1/sendEmailToCustomer",
      JSON.stringify({
        name: formData.name,
        phone: formData.phone,
        email: formData.email,
        message: formData.message,
      }),
      {
       headers: {
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded"
  }
      }
    );

    console.log("API Response:", response.data);

    setSuccessMessage("Thank you for your message. It has been sent.");

    setFormData({
      name: "",
      email: "",
      phone: "",
      message: "",
    });

    setTimeout(() => {
      setSuccessMessage("");
    }, 5000);

  } catch (error) {
    console.error("API Error:", error.response || error);
    setSuccessMessage("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
  }
};

  return (
    <section id="contact" className="contact-section">
      <h2>Contact Us</h2>
      <p className="contact-subtitle">
        Get in touch with us for project enquiries or site visits
      </p>

      <div className="contact-layout">

        {/* LEFT SIDE */}
        <div className="contact-left">

          <div className="contact-card">
            <div className="info-item">
              <Phone />
              <div>
                <h4>Phone</h4>
                <p>+91 7022215439</p>
              </div>
            </div>

            <div className="info-item">
              <Mail />
              <div>
                <h4>Email</h4>
                <p>info@jayaramgroup.com</p>
              </div>
            </div>

            <div className="info-item">
              <MapPin />
              <div>
                <h4>Address</h4>
                <p>
                  #25, First Floor, Serpentine Road, Kumar Park West Bengaluru - 560020
                </p>
              </div>
            </div>
          </div>

          {/* MAP */}
          <div className="map-card">
            <iframe
              title="Jayram InfraCon Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.874507890678!2d77.5804408!3d12.9942757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8ebf6e4709808a33%3A0x24d2539043094c9!2sJayaram%20Infracon%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1707130000000"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

        </div>

        {/* RIGHT SIDE FORM */}
        <form className="contact-form" onSubmit={handleSubmit}>

          {/* ✅ Success Message */}
          {successMessage && (
            <div className="success-message">
              {successMessage}
            </div>
          )}

          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />

          <textarea
            rows="4"
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
          />

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Message"}
          </button>

        </form>

      </div>
    </section>
  );
};

export default Contact;
